/**
 * PopularTagsSection — community reader "vibe" tags (slow burn, found
 * family, ...). See data/tagPool.js — no real tagging system exists yet,
 * so this is deterministic mock data, structured to slot into a future
 * community-tags endpoint without changing this component.
 */

import React from 'react';
import { Badge } from '@/components/site/primitives';

const TONES = ['coral', 'sage', 'yellow', 'blue'];

export default function PopularTagsSection({ tags }) {
  if (!tags?.length) return null;

  return (
    <section className="u-container mt-10 md:mt-14" data-testid="book-details-tags">
      <h2 className="font-display text-lg font-semibold text-ink">Popular Reader Tags</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {tags.map((tag, i) => (
          <Badge key={tag} tone={TONES[i % TONES.length]}>{tag}</Badge>
        ))}
      </div>
    </section>
  );
}
